// extracted by mini-css-extract-plugin
export default {"title":"DynamicsScreen_title__DuL75","body":"DynamicsScreen_body__TdHeo"};